import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import errorHandler from '@/layout/components/error/ErrorHandler';
import Translator from '@/layout/components/helpers/Translator';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import AuxSidebar from '@/layout/Sidebar/AuxSidebar';
import colors from '@/constants/colors';
import { axiosPath, path } from '@/routing/helpers/router';
import * as currentPageAction from '@/store/actions/currentPageAction';

export default function GlobalImportMilestoneSidebarBlock() {
    const { moduleBridgeHex } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isMounted = useIsMounted();
    const auxSidebar = useSelector(
        (state) => state.currentPage?.auxSidebar?.opened,
    );
    const [openOnce, setOpenOnce] = useState(false);
    const [milestones, setMilestones] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleAuxSidebar = () => {
        if (!openOnce) {
            setOpenOnce(true);
        }
        if (auxSidebar !== 'importMilestones') {
            dispatch(
                currentPageAction.change('auxSidebar', { opened: 'importMilestones' }),
            );
        } else {
            dispatch(currentPageAction.change('auxSidebar', { opened: null }));
        }
    };

    useEffect(() => {
        if (!openOnce) {
            return;
        }

        setIsLoading(true);
        axios
            .post(
                axiosPath(
                    'api_r_user_module_globalLegalCompliance_import_getImportMilestones',
                ),
                { moduleBridgeHex },
            )
            .then(({ data }) => {
                if (isMounted.current) {
                    setMilestones(data);
                    setIsLoading(false);
                }
            })
            .catch((e) => {
                if (isMounted.current) {
                    setIsLoading(false);
                }
                dispatch(errorHandler(e));
            });
    }, [openOnce, moduleBridgeHex, dispatch, isMounted]);

    const handleSelect = (milestoneId) => {
        dispatch(currentPageAction.change('auxSidebar', { opened: null }));
        navigate(
            path({
                name: 'user_module_globalLegalCompliance_import',
                params: {
                    moduleBridgeHex,
                    importMilestoneId: milestoneId,
                },
            }),
        );
    };

    return (
        <>
            <li
                className={auxSidebar && auxSidebar === 'importMilestones' ? 'active' : ''}
                onClick={handleAuxSidebar}
            >
                <span className="sidebar-element">
                    <AppRemixIcon icon="file-history" className="sidebar-icon" />{' '}
                    <span className="sb-title">
                        <Translator
                            file="module-globallegalCompliance"
                            name="user.import.milestone"
                        />
                    </span>
                </span>
            </li>
            <AuxSidebar
                title={
                    <Translator
                        file="module-globallegalCompliance"
                        name="user.import.milestone"
                    />
                }
                isOpen={auxSidebar && auxSidebar === 'importMilestones'}
                width="350px"
                position="left"
                onClose={handleAuxSidebar}
            >
                {openOnce && (
                    <>
                        {isLoading ? (
                            <AppNoInfo />
                        ) : milestones?.length > 0 ? (
                            milestones.map((milestone) => (
                                <MilestoneTitle
                                    key={milestone.id}
                                    onClick={() => handleSelect(milestone.id)}
                                >
                                    {milestone.name}
                                </MilestoneTitle>
                            ))
                        ) : (
                            <div className="alert alert-info">
                                <Translator
                                    file="module-globallegalCompliance"
                                    name="there.are.no.import.milestones"
                                />
                            </div>
                        )}
                    </>
                )}
            </AuxSidebar>
        </>
    );
}

const MilestoneTitle = styled.div`
    color: ${colors.primary};
    font-size: 14px;
    margin-bottom: 10px;
    cursor: pointer;
`;
